import React from 'react';
import styled from 'styled-components';
import { Search, useNavigate } from 'react-router-dom';

import { themes, division } from '../appData';
import { useTokens } from './SamState';
import { usePostApi } from './useDataApiV2';

import { WSSearchResultRecord } from '../interfaces/ws-api-interfaces';

import api from '../api-url';

const StyledSearchIcon = styled.div`
    display: flex;
    flex-direction: column;
    font-size: 32px;
`
const StyledSearchBoxAndStatus = styled.div`
    margin: 8px auto;
    width: 300px;
`
const StyledSearchBox = styled.input`
    width: 100%;
`
const StyledSearchErrorText = styled.p<{ $backColor: string }>`
    margin: 16px;
    margin-top: 8px;
    color: red;
    font-weight: bold;
    border: solid 1px red;
    background-color: ${props => props.$backColor};
`
interface SearchPopupProps {
    isOpen: boolean;
    handleOpen: () => void;
    handleClose: () => void;
}
const SearchPopup: React.FC<SearchPopupProps> = (props) => {
    const { post, isPostLoading } = usePostApi();
    const { getToken } = useTokens();
    const navigate = useNavigate();

    const [currSearchText, setCurrSearchText] = React.useState<string>();
    const [noHitsShown, setNoHitsShown] = React.useState<boolean>(false);
    const searchBoxRef = React.useRef<HTMLInputElement>() as React.MutableRefObject<HTMLInputElement>;

    const handleSearchKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter") {
            doSearch();
        }
    }
    const handleIconClicked = () => {
        if (props.isOpen) {
            doSearch();
        } else {
            props.handleClose();
            props.handleOpen();
        }
    }
    const postSucceeded = (result: WSSearchResultRecord[]) => {
        if (result.length === 0) {
            if (!noHitsShown) {
                setNoHitsShown(true);
            }
        } else {
            if (noHitsShown) {
                setNoHitsShown(false);
            }
            navigate("/search", { state: result });
        }
    }
    const postFailed = () => {
        if (!noHitsShown) {
            setNoHitsShown(true);
        }
    }
    const doSearch = () => {
        const searchText = searchBoxRef.current.value;
        if (searchText !== currSearchText) {
            post(api.search, { searchText, division: division, excludePrepacks: !getToken() }, postSucceeded, postFailed);
            setCurrSearchText(searchText);
        }
    }

    return (
        <>
            {props.isOpen &&
                <StyledSearchBoxAndStatus>
                    <StyledSearchBox ref={searchBoxRef} placeholder="SEARCH" onKeyDown={handleSearchKeyDown} />
                    <div>
                        {isPostLoading(api.search) && <i className="fa fa-spinner fa-spin spinner48"></i>}
                        {noHitsShown &&
                            <StyledSearchErrorText $backColor={themes.backColor10}>No matching products found.</StyledSearchErrorText>
                        }
                    </div>
                </StyledSearchBoxAndStatus>
            }
            <StyledSearchIcon onClick={handleIconClicked}>
                <i className="fas fa-search" />
            </StyledSearchIcon>
        </>
    );

}

export default SearchPopup;